import { createRoute, redirect } from "@tanstack/react-router";
import { guestLinkProfile, GuestPassRetiredPage } from "pages/app/GuestPassRetiredPage";

import { appRoutes } from "lib/appRoutes";
import { rootRoute } from "../rootRoute";

// /guest_access/* — every old guest-pass link lands here. Rails serves the prefix publicly, so
// visitors without a session see the page; `noShell` keeps the app chrome off it.
export const guestAccessRetiredRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/guest_access/$",
  staticData: { pageName: "Guest pass retired", noShell: true },
  beforeLoad: ({ location }) => {
    // A signed-in customer goes straight to the profile the link pointed at.
    if (!window.userSignedIn) return;
    const profile = guestLinkProfile(location.pathname);
    if (!profile) return;
    const target =
      profile.kind === "buyer"
        ? appRoutes.buyerDetail(profile.id)
        : appRoutes.supplierDetail(profile.id);
    throw redirect({ ...target, replace: true });
  },
  component: GuestPassRetiredPage,
});
